import React from 'react';

import {
    ActionbuttonsContainer,
    StyledGreenButton,
    StyledWhiteButton,
} from '@/operator/components/general/button/Styles';

interface EditUserActionsProps {
    onClickSaveChanges: () => void;
    onClickCancelChanges: () => void;
    disableButtons: boolean;
}

const EditUserActions: React.FC<EditUserActionsProps> = ({
    onClickSaveChanges,
    onClickCancelChanges,
    disableButtons,
}) => {
    return (
        <ActionbuttonsContainer
            style={{
                position: 'absolute',
                transform: 'translateY(-85px)',
                right: '134px',
            }}
        >
            <StyledGreenButton
                onClick={onClickSaveChanges}
                size="small"
                variant="contained"
                disabled={disableButtons}
            >
                Save Changes
            </StyledGreenButton>
            <StyledWhiteButton
                disabled={disableButtons}
                onClick={onClickCancelChanges}
            >
                Cancel
            </StyledWhiteButton>
        </ActionbuttonsContainer>
    );
};

export default EditUserActions;
